import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import UserUtil from "../constants/user";
import PermitCtrl from "@/utils/permitctrl";
import { ElMessageBox } from 'element-plus';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    redirect: '/navigate',
    children:[
      {path: '/navigate',component: () => import('../views/common/NavigateView.vue')},
      {path: '/myI',component: () => import('../views/common/MyInfo.vue')},
      {path: '/examL',component: () => import('../views/student/ExamList.vue')},
      {path: '/examM',component: () => import('../views/teacher/ExamManage.vue')},
      {path: '/examP',component: () => import('../views/student/ExamPrepare.vue')},
      {path: 'examA',component: () => import('../views/student/ExamAnswer.vue')},
      {path: '/questionM',component: () => import('../views/teacher/QuestionManage.vue')},
      /*{path: '/questionL',component: () => import('../views/question/QuestionList.vue')},*/
      {path: '/bankV',component: () => import('../views/teacher/BankView.vue')},
      {path: '/scoreQ',component: () => import('../views/student/ScoreQuery.vue')},
      {path: '/reviewP',component: () => import('../views/teacher/ReviewPaper.vue')},
      {path: '/paperG',component: () => import('../views/teacher/PaperGrade.vue')},
      {path: '/scoreA',component: () => import('../views/teacher/ScoreAnalyze.vue')},
      {path: '/studentM',component: () => import('../views/teacher/StudentManage.vue')},
      {path: '/scoreD/:examId',component: () => import('../views/student/ScoreDetail.vue'),props:true},
      {path: '/userM',component: () => import('../views/admin/UserManage.vue')},
      {path: '/fixedV',component: () => import('../views/teacher/FixedView.vue')},
      {path: '/safeL',component: () => import('../views/admin/SafeLog.vue')},
      {path: '/dataC',component: () => import('../views/admin/DataCount.vue')},
      {path: '/hallV',component: () => import('../views/teacher/HallView.vue')},
      {path: '/monitorV',component: () => import('../views/teacher/MonitorView.vue')},
      {path: '/errorA',component: () => import('../views/student/ErrorAnalyze.vue')},
      {path: '/dataS',component: () => import('../views/admin/DataSensitive.vue')},
    ]
  },
  {path: '/login',component: () => import('../views/common/LoginView.vue')},
  {path: '/register',component: () => import('../views/common/RegisterView.vue')},
  {path: '/authV',component: () => import('../views/common/AuthView.vue')}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  const hasPerm = PermitCtrl.hasPermission(to);
  if (hasPerm) {
    next(); // 有权限，继续跳转
  } else {
    // 无权限：未登录跳登录；已登录提示无权限并询问是否跳登录页
    if (!UserUtil.getCurrentUser()) {
      next('/login');
    } else {
      // 使用Element Plus的确认对话框
      ElMessageBox.confirm(
        '你没有访问该页面的权限！是否跳转到登录页？',
        '权限提示',
        {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }
      ).then(() => {
        // 用户点击"是"，跳转到登录页
        next('/login');
      }).catch(() => {
        // 用户点击"否"，取消跳转
        next(false);
      });
    }
  }
});

export default router
